import { render, staticRenderFns } from "./CollaborativeTaskDetails.vue?vue&type=template&id=d1bedc90&scoped=true"
import script from "./CollaborativeTaskDetails.vue?vue&type=script&lang=js"
export * from "./CollaborativeTaskDetails.vue?vue&type=script&lang=js"
import style0 from "./CollaborativeTaskDetails.vue?vue&type=style&index=0&id=d1bedc90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1bedc90",
  null
  
)

export default component.exports